@for (vap of vaps; track vap; let i = $index) {
  <div class="addon-expander addon-expander--checkbox">
    <div class="addon-expander__header">
      <label class="custom-input custom-input--checkbox">
        <input type="checkbox" [checked]="vap?.checked" [id]="'checkbox' + currentVap?.product_vaps_id + '-' + vap?.session_item_id"
          [class]="'addon-' + currentVap?.product_vaps_id" (click)="checkAddon(i)"/>
          <span class="custom-input__indi"></span>
        </label>
        <a [href]="'#addon-vehicle-field-' + vap?.session_item_id"
          (click)="$event.preventDefault();"
          class="addon-expander__title"
          [ngClass]="{'collapsed': !vap?.show}"
          data-toggle="collapse"
          aria-expanded="false">
          <h6>{{vap?.description[2]}}</h6>
          <div class="addon-expander__cost" [ngClass]="vap?.is_active ? 'is-active' : ''">
            <p>
              <strong [class]="currentVap?.product_vaps_id + '-' + vap?.session_item_id + '-price addon-price-' + currentVap?.product_vaps_id + ' addon-' + currentVap?.product_vaps_id">
              {{vap?.price | currency:'ZAR':'R':'1.0-0'}}</strong> /mo
            </p>
          </div>
          <div class="addon-expander__caret">
            <svg class="icon">
              <use xlink:href="#dropdown"></use>
            </svg>
          </div>
        </a>
      </div>
      <div class="addon-expander__content collapse" [ngClass]="{'show': vap?.show}" [id]="'addon-vehicle-field-' + vap?.session_item_id">
        <div class="modal-addons__item">
          <div class="form-group">
            <app-question-dropdown
              [showLabel]="true"
              [labelText]="question?.question_copy"
              [readOnly]="false"
              [question]="question"
              [selectedValue]="vap?.option_id"
              (questionAnswer)="selectChange($event, i)">
            </app-question-dropdown>
            <br>
              <br>
                <input type="number"
                  placeholder="# Days"
                  mask="999 999"
                  [allowNegativeNumbers]="false"
                  [dropSpecialCharacters]="true"
                  [(ngModel)]="vap.value"
                  (ngModelChange)="onChange(i, 0)"
                  [class]="'form-control answers days ' + question?.cent_aq_question_id"/>
                </div>
              </div>
            </div>
          </div>
        }
